"use client";

import { useAppContext } from "@/context/AppContextProvider";
import { FilterImageCategory, TabItem } from "../hooks/useGalleryCategory";
import React, { FC, useEffect } from "react";



type Props = {
  tabs: TabItem[];
  category: FilterImageCategory;
  handleCategoryChange: (selectedTab: FilterImageCategory) => void
  className?: string;
  buttonClassName?: string;
  isContest?: boolean;
}

const GallaryTabSwitcher: FC<Props> = ({ tabs, handleCategoryChange, category, className = "", buttonClassName = "" , isContest = false}) => {

  // リサイズイベントを発火して画面のレイアウトを調整
  useEffect(() => {
    setTimeout(() => {
      if (window !== undefined) {
        window.dispatchEvent(new Event("resize"));
      }
    }, 100);
  }, []);

  const getClassName = ({category, tab} : {category: FilterImageCategory; tab: TabItem; }) => {
    
    if(isContest) {
      return '';
    }

    return category === tab.value ? 'border-b-2 border-gray-100 rounded-none' : '';
    
  }

  return (
    <div className={`text-white flex  ${className}`}>
      {tabs.map((tab) => (
        <button
          key={String(tab.value)}
          onClick={(e) => {
            e.stopPropagation();
            if (tab.clickTab) {
              tab.clickTab();
            }
            else {
              handleCategoryChange(tab.value)
            }
            if (tab.clickTabCallback) {
              tab.clickTabCallback();
            }
          }}
          className={`text-[min(3vw,14px)] mx-2 px-2  ${getClassName({category, tab})} ${buttonClassName} ${tab.className ?? ''} `}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default GallaryTabSwitcher;